import { toUrlParameters } from './util';
export class TranslationRemoteRepository {
    constructor(fetcher, contextId) {
        this.fetcher = fetcher;
        this.contextId = contextId;
    }
    async getTranslations(locale) {
        const params = {
            locale: locale,
            contextId: this.contextId
        };
        const response = await this.fetcher.fetchGetJson(`${TranslationRemoteRepository.TRANSLATIONS_PATH}?${toUrlParameters(params)}`);
        return TranslationRemoteRepository.mapResponseTranslations(response);
    }
    static mapResponseTranslations(response) {
        return response;
    }
}
TranslationRemoteRepository.TRANSLATIONS_PATH = '/api/translations';
